module.exports = __webpack_public_path__ + "img/Straight-Knee-Boots_fr.6d2854c8.jpg";